function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// @ts-nocheck
import * as React from 'react';
export default class Form extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "validate", void 0);

    _defineProperty(this, "onChange", void 0);

    _defineProperty(this, "onBlur", void 0);

    _defineProperty(this, "submit", void 0);
  }

} // }